<template>
    <div class="screening-data-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-8 filter-title-section">
                    <h2>Record Status</h2>
                </div>
                <div class="col-md-4 text-right">
                    <div class="row">
                        <div class="col-md-9">
                            <base-search
                                placeholder="Search record status"
                                @keyword="getKeyword"
                            ></base-search>
                        </div>
                        <div class="col-md-3">
                            <button
                                class="btn btn-primary"
                                type="submit"
                                :class="
                                    loading && showPageLoader ? 'disabled' : ''
                                "
                                @click="apply"
                            >
                                <span class="btn-text">Apply</span>
                                <span class="loader"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'mobile-table-responsive-sm',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-status-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <modify-status-popup
            modal-title="Modify Record Status"
        ></modify-status-popup>
        <base-records
            path="screening-data/filters/recordStatus"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyStatusPopup from '@/components/popups/ModifyStatusPopup.vue'
export default {
    components: {
        modifyStatusPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'value',
                    label: 'Record Status',
                    class: 'w-320px',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return `${item.value.charAt(0).toUpperCase() +
                            value.slice(1).replace(/_/g, ' ')}`
                    },
                },
                {
                    key: 'status',
                    label: 'Status',
                    class: 'text-center',
                    sortable: true,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            items: [],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'value',
                sortOrder: 'asc',
                source: 'dowJones',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.apply()
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
